const fromCancelAppointmentQueryToAppointment = (data) => {
  if (!data) {
    return null;
  }
  const {
    status,
    id,
    invitee,
    appointmentType,
    startTime,
    endTime,
    store,
    storeInfo,
    child,
    preferredChannelOfCommunication
  } = data;
  return {
    status,
    id,
    endTime: new Date(endTime),
    startTime: new Date(startTime),
    invitee: invitee ? { firstName: invitee.firstName, lastName: invitee.lastName ?? void 0 } : void 0,
    appointmentType: appointmentType ? {
      id: appointmentType.id,
      name: appointmentType.name,
      ageGroup: appointmentType.ageGroup,
      description: appointmentType.description,
      duration: {
        amount: appointmentType.duration.amount,
        unit: appointmentType.duration.unit
      },
      isVisibleToCustomers: appointmentType.visibleToCustomers
    } : void 0,
    store: store ? { code: store.code } : void 0,
    storeInfo: storeInfo ? { globalStoreId: storeInfo.globalStoreId } : void 0,
    child: child ? { firstName: child.firstName, lastName: child.lastName ?? void 0 } : void 0,
    preferredChannelOfCommunication: preferredChannelOfCommunication ?? void 0
  };
};
export {
  fromCancelAppointmentQueryToAppointment
};
//# sourceMappingURL=fromCancelAppointmentQueryToAppointment.js.map
